const link = `https://www.googleoptimize.com/optimize.js?id=${process.env.GATSBY_OPTIMIZE_ID}`

export default link
